import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import GoogleMapComponent from "../../../components/GoogleMap";
import appcolors from "../../../constants/Colors";
import { allIcons } from "../../../assets";

const style = {
  muiTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
    },
  },
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "900px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const AddEditAddress = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isMapLoading, setIsMapLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={"lg"}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <Box p={2}>
        <DialogTitle
          variant="h1"
          fontWeight={500}
          fontSize={"1.5rem"}
          fontFamily={"inter"}
          id="customized-dialog-title"
          sx={{ p: 0 }}
        >
          Location
        </DialogTitle>
        <Typography variant="body2" color={appcolors.slateGrey}>
          Please search or select location
        </Typography>
      </Box>
      <Stack
        gap={1.5}
        direction={"row"}
        p={"8px 16px"}
        alignItems={"center"}
        justifyContent={"space-between"}
        bgcolor={appcolors.primaryLight}
      >
        <TextField
          sx={style.muiTextField}
          placeholder="Search Name"
          variant="outlined"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ cursor: "pointer" }}>
                <img src={allIcons.searchIcon} alt="search-icon" width={25} />
              </InputAdornment>
            ),
          }}
        />
        <Stack
          direction={"row"}
          alignItems={"center"}
          gap={1}
          sxx={{ cursor: "pointer" }}
        >
          <img src={allIcons.locationIcon} alt="location-icon" width={20} />
          <Typography variant="body2" color={appcolors.slateGrey}>
            Current Location
          </Typography>
        </Stack>
      </Stack>
      <DialogContent>
        {isMapLoading ? (
          <Box
            height={300}
            position={"relative"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box width={"100%"} overflow={"auto"} mt={2}>
            <GoogleMapComponent
              searchText={searchText}
              setIsLoading={setIsMapLoading}
            />
          </Box>
        )}
      </DialogContent>
    </BootstrapDialog>
  );
});

export default AddEditAddress;
